import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  NgModule,
  OnDestroy,
} from "@angular/core";
import { Route, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { CommonApiService } from "./../shared/services/api/common-api.service";
import { ViewStateService } from "./../shared/services/view-state.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-licensure-list",
  templateUrl: "./licensure-list.component.html",
})
export class LicensureListComponent implements OnInit, OnDestroy {
  licensureList: any[];
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private viewState: ViewStateService,
    private commonApiService: CommonApiService,
    private router: Router
  ) {}

  ngOnInit() {
    this.viewState.startLoading();
    this.getStateLicensures();
  }

  private setupFormListeners() {
    // this.paymentForm
    // .controls['agencyId']
    // .valueChanges
    // .subscribe(id => {
    //   let exam = this.examList.find(e => e.serviceId == id);
    //   this.examFee = exam ? exam.activeRate : 0;
    //   this.examId = exam ? exam.examId : 0;
    //   this.updateFee();
    // });
  }

  private getStateLicensures() {
    this.commonApiService
      .getStateLicensures()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.licensureList = res;
        this.viewState.stopLoading();
      });
  }

  formatPhone(phone: string) {
    let phoneString = "";
    if (phone.length === 10) {
      phoneString =
        phone.substr(0, 3) +
        "." +
        phone.substr(3, 3) +
        "." +
        phone.substr(6, 4);
    } else if (phone.length === 11) {
      phoneString =
        "1." +
        phone.substr(1, 3) +
        "." +
        phone.substr(4, 3) +
        "." +
        phone.substr(7, 4);
    } else {
      phoneString = phone;
    }
    return phoneString;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
